import React, { Fragment } from "react";
import { ProductInfo } from "@nykaa/payment-ui/src/ProductInfo";
import { Products } from "../../@types";
import { ProductsWrapper } from "../../assets/style";


export const BagDetails = ({ items, theme }: Products) => (
  <ProductsWrapper className="product-wrapper">
    {items?.map((item, index) => (
      <Fragment key={`product-${index}`}>
        <ProductInfo
          productName={item.productName}
          onProductNameClick={item.onProductNameClick}
          productImage={item.productImage}
          productVariant={item.productVariant}
          finalPrice={item.finalPrice}
          originalPrice={item.originalPrice}
          isFreeSample={item.isFreeSample}
          showBinIcon={item.showBinIcon}
          selectedQuantity={item.selectedQuantity}
          theme={theme}
        />
      </Fragment>
    ))}
  </ProductsWrapper>
);
